import React, { useEffect, useState } from "react";
import Common_Back_Btn from "../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import Complaint_Report_Filter from "./complaint_report_filter/Complaint_Report_Filter";
import Complaint_Report_Table from "./complaint_report_table/Complaint_Report_Table";
import Common_Report_Offcanvas from "../../common_report_offcanvas/Common_Report_Offcanvas";
import { useDispatch, useSelector } from "react-redux";
import {
  GetComplanintReport,
  GetCustomerReport,
} from "../../../../../features/admin/report_generator/Slice";
import { GetAll } from "../../../../../features/admin/quality_management/process_requirement/complaint/Slice";
import { FixIDS } from "../../../../../utils/fixIDS";

const Complaint_Report = () => {
  const [show, setShow] = useState(false);
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const complaintsdetails = useSelector((state) => state.complaint);
  const [isEdit, setIsEdit] = useState(false);
  const [editId, setEditId] = useState(null);

  const handleEdit = (id) => {
    setEditId(id);
    setIsEdit(true);
  };

  const permissions = useSelector((state) => state.auth.permissions);
  const haveReportPermission = permissions?.includes(
    FixIDS.complaint_report.Report,
  );

  const [searchParams, setSearchParams] = useState({
    complaint_status_id: "",
    complaint_nature_id: "",
    end_date: "",
    start_date: "",
  });
  const fetchCustomers = async (page = 1) => {
    await dispatch(
      GetAll({
        page,
        per_page: complaintsdetails.per_page,
        complaint_status_id: searchParams?.complaint_status_id?.value,
        complaint_nature_id: searchParams?.complaint_nature_id?.value,
        end_date: searchParams.end_date,
        start_date: searchParams.start_date,
      }),
    );
  };

  useEffect(() => {
    fetchCustomers(currentPage);
  }, [currentPage, searchParams]);

  const [showLottie, setShowLottie] = useState(true);
  const [reportPath, setReportPath] = useState("");

  const reportgenerate = async (page) => {
    setShow(true);
    setShowLottie(true);
    const response = await dispatch(
      GetComplanintReport({
        page,
        per_page: complaintsdetails.per_page,
        complaint_status_id: searchParams?.complaint_status_id?.value,
        complaint_nature_id: searchParams?.complaint_nature_id?.value,
        end_date: searchParams.end_date,
        start_date: searchParams.start_date,
      }),
    );

    if (response?.meta?.requestStatus === "fulfilled") {
      const path = response?.payload?.path;
      setReportPath(path);
      setShowLottie(false);
    } else {
      setShowLottie(false); // also stop loader on error
    }
  };
  return (
    <section className="Sample_Report">
      <div className="back_div">
        <Common_Back_Btn backText="Complaint Report" />
      </div>

      <div className="Sample_Report_Filter_div">
        <Complaint_Report_Filter
          setShow={setShow}
          reportgenerate={reportgenerate}
          setSearchParams={setSearchParams}
        />
      </div>

      <div className="report_table_div">
        {haveReportPermission && (
          <Complaint_Report_Table
            complaintsdetails={complaintsdetails}
            setCurrentPage={setCurrentPage}
            currentPage={currentPage}
          />
        )}
      </div>
      <Common_Report_Offcanvas
        reportPath={reportPath}
        reportgenerate={reportgenerate}
        setShowLottie={setShowLottie}
        showLottie={showLottie}
        title={"Complaint Report"}
        show={show}
        setShow={setShow}
        handleClose={() => {
          setShow(false);
        }}
      />
    </section>
  );
};

export default Complaint_Report;
